<template>
  <v-dialog
    v-model="show"
    max-width="450px"
    persistent
  >
    <v-card>
      <v-card-title>
        Styles
        <v-spacer />
        <v-btn
          icon
          @click="close()"
        >
          <v-icon color="error">
            mdi-close
          </v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="pt-4">
        <v-container class="px-0">
          <v-row v-if="style">
            <v-col cols="12">
              <v-text-field
                v-model.number="style.charLen"
                clearable
                label="Characters Length"
                outlined
                dense
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <v-autocomplete
                v-model="style.decoration"
                clearable
                label="Decorations"
                :items="decorationTypes"
                item-text="label"
                item-value="id"
                outlined
                dense
                hide-details
              >
                <template v-slot:item="data">
                  <v-list-item-content>
                    <v-list-item-title v-html="data.item.label" />
                    <v-list-item-subtitle v-html="data.item.description" />
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-autocomplete
                v-model="style.fontFamily"
                clearable
                label="FontFamily"
                :items="fontFamilyTypes"
                item-text="label"
                item-value="id"
                outlined
                dense
                hide-details
              >
                <template v-slot:item="data">
                  <v-list-item-content>
                    <v-list-item-title v-html="data.item.label" />
                    <v-list-item-subtitle v-html="data.item.description" />
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-autocomplete
                v-model="style.fontSize"
                clearable
                label="FontSize"
                :items="fontSizeTypes"
                item-text="label"
                item-value="id"
                outlined
                dense
                hide-details
              >
                <template v-slot:item="data">
                  <v-list-item-content>
                    <v-list-item-title v-html="data.item.label" />
                    <v-list-item-subtitle v-html="data.item.description" />
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-autocomplete
                v-model="style.fontStyle"
                clearable
                label="FontStyle"
                :items="fontStyleTypes"
                item-text="label"
                item-value="id"
                outlined
                dense
                hide-details
              >
                <template v-slot:item="data">
                  <v-list-item-content>
                    <v-list-item-title v-html="data.item.label" />
                    <v-list-item-subtitle v-html="data.item.description" />
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-autocomplete
                v-model="style.fontWeight"
                clearable
                label="FontWeight"
                :items="fontWeightTypes"
                item-text="label"
                item-value="id"
                outlined
                dense
                hide-details
              >
                <template v-slot:item="data">
                  <v-list-item-content>
                    <v-list-item-title v-html="data.item.label" />
                    <v-list-item-subtitle v-html="data.item.description" />
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-autocomplete
                v-model="style.justify"
                clearable
                label="Justify Content"
                :items="justifiesTypes"
                item-text="label"
                item-value="id"
                outlined
                dense
                hide-details
              >
                <template v-slot:item="data">
                  <v-list-item-content>
                    <v-list-item-title v-html="data.item.label" />
                    <v-list-item-subtitle v-html="data.item.description" />
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-divider />
      <v-card-actions class="px-6">
        <v-spacer />
        <v-btn
          color="error"
          @click="close()"
        >
          Close
        </v-btn>
        <v-btn
          color="success"
          @click="updateStyle()"
        >
          Update
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "StylesConfig",
  props: {
    showStyle: {
      type: Boolean,
      default: false
    },
    styleConfig: {
      type: Object,
      default: () => {}
    },
    templateMasters: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      styleInfo: null
    };
  },
  computed: {
    show: {
      get() {
        return this.showStyle;
      },
      set(val) {
        this.$emit("update:showStyle", val);
      }
    },
    decorationTypes() {
      return this.templateMasters?.decoration || [];
    },
    fontFamilyTypes() {
      return this.templateMasters?.fontFamily || [];
    },
    fontSizeTypes() {
      return this.templateMasters?.fontSize || [];
    },
    fontStyleTypes() {
      return this.templateMasters?.fontStyle || [];
    },
    fontWeightTypes() {
      return this.templateMasters?.fontWeight || [];
    },
    justifiesTypes() {
      return this.templateMasters?.justifies || [];
    },
    style() {
      return this.styleInfo;
    }
  },
  watch: {
    show(v) {
      if (v) {
        console.log(this.styleConfig, "Style Passed");
        this.styleInfo = JSON.parse(JSON.stringify(this.styleConfig.style));
      }
    }
  },
  methods: {
    close() {
      this.$emit("update:showStyle", false);
    },
    updateStyle() {
      this.$emit("updateStyle", {
        refId: this.styleConfig.refId,
        style: this.style
      });
    }
  }
};
</script>